<template>
  <v-row no-gutters class="wrapper">
    <v-col class="relative" cols="12">
      <template v-if="keywords && keywords.length === 0">
        <div class="no-keywords">
          <img
            src="@/static/analytics/noPeriodicChart.svg"
            alt="No keywords added."
          />
          <p class="no-keywords__description">
            {{ $t("message.analytics.periodic.table.noKeywordsDescription") }}
          </p>
        </div>
      </template>

      <template v-if="keywords && keywords.length > 0">
        <v-row no-gutters>
          <v-col cols="12">
            <div
              v-if="table && table.data && table.data.length > 0"
              class="mb-8"
            >
              <Pagination
                :page="table.page"
                :per-page="table.perPage"
                :options="table.perPageOptions"
                :total-count="table.totalCount"
                @change="handleChange"
                class="mb-2"
              ></Pagination>

              <PeriodicTable
                ref="table"
                :keywords="keywords"
                :page="table.page"
                :per-page="table.perPage"
                :table-data="table.data"
                :table-summary="table.summary"
                :is-grouped-data="table.grouped"
                :data-type="dataType"
                :count="table.totalCount"
                :report-type="selectedReportType"
                class="periodic-table"
                @sort="$emit('sort', $event)"
              />

              <Pagination
                :page="table.page"
                :per-page="table.perPage"
                :options="table.perPageOptions"
                :total-count="table.totalCount"
                :show-options="false"
                @change="handleChange"
                class="mt-2"
              ></Pagination>
            </div>
            <NoData
              class="no-data"
              v-else-if="table && table.data && table.data.length === 0"
            />
          </v-col>
        </v-row>
      </template>
      <SectionLoader :status="loading.table" :opacity="0.75" />
    </v-col>
  </v-row>
</template>

<script>
import PeriodicTable from "@/components/Analytics/Periodic/Table";
import Pagination from "@/components/List/Pagination";
import NoData from "@/components/ui/NoData";
import SectionLoader from "@/components/Loader/SectionLoader";

import { gtmEngagement as gtmEngagementMixin } from "@/helpers/mixins/gtm-engagement";
import { PERIODIC_REPORT_TYPE } from "@/enums/charts-type.enum";
import { FACILITIES_FILTER_SEARCH_TYPES } from "@/enums/facilty-details-status.enum";

export default {
  name: "PeriodicTableTab",
  components: {
    PeriodicTable,
    Pagination,
    NoData,
    SectionLoader
  },
  mixins: [gtmEngagementMixin],
  props: {
    loading: {
      type: Object,
      required: true
    },
    keywords: {
      type: Array,
      required: true
    },
    table: {
      type: Object,
      required: true
    },
    dataType: {
      type: String,
      validator: val =>
        Object.values(FACILITIES_FILTER_SEARCH_TYPES).includes(val)
    },
    selectedReportType: {
      type: Number,
      required: true,
      validator: val => Object.values(PERIODIC_REPORT_TYPE).includes(val)
    }
  },

  watch: {
    "table.data": async function() {
      await this.renderTable();
    }
  },

  async created() {
    await this.renderTable();
  },

  mounted() {
    this.mixin__setGtmEngagementTimeouts();
  },

  methods: {
    async renderTable() {
      await this.$nextTick(() => {
        if ("table" in this.$refs) {
          this.$refs["table"].renderTable();
        }
      });
    },
    handleChange({ page, perPage }) {
      this.$emit("tablePagination", { page, perPage });
    },
    setLoading(value) {
      this.$emit("setLoading", "table", value);
    }
  }
};
</script>

.<style lang="scss" scoped>
.wrapper {
  padding: 0 $spacing * 3;
}

.no-keywords {
  @include noData(650px);

  &__description {
    @include font-size(22px);
    text-align: center;
    margin: $spacing * 5 0 $spacing * 3;
    white-space: pre-line;
  }
}

.periodic-table {
  min-height: 100px;
}

.no-data {
  @include noData(500px);
}

.relative {
  position: relative;
}
</style>
